import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { getPostsByType } from './posts/index.js';
import { SectionLabel, PostList } from '../sections/site-chrome.js';
import theme from '../theme';

const t = theme;

function Section({ index, label, posts }) {
  if (posts.length === 0) return null;

  return (
    <Box component="section" sx={{ pb: { xs: 5, md: 7 } }}>
      <SectionLabel index={index}>{label}</SectionLabel>
      <PostList posts={posts} />
    </Box>
  );
}

function WritingsList() {
  const caseStudies = getPostsByType('case-study');
  const posts = getPostsByType('post');

  return (
    <Box>
      <Box sx={{ pt: { xs: 6, md: 10 }, pb: { xs: 5, md: 7 } }}>
        <Typography
          component="h1"
          sx={{
            fontSize: { xs: '1.75rem', md: '2.25rem' },
            fontWeight: t.typography.fontWeight.medium,
            lineHeight: t.typography.lineHeight.tight,
            letterSpacing: t.typography.letterSpacing.tight,
            color: t.colors.textPrimary,
            mb: 2
          }}
        >
          Writing
        </Typography>
        <Typography
          sx={{
            fontSize: t.typography.fontSize.lg,
            lineHeight: t.typography.lineHeight.relaxed,
            color: t.colors.textSecondary,
            maxWidth: 560
          }}
        >
          Thoughts on product design, building SaaS, and lessons learned from
          turning ideas into shipped products.
        </Typography>
      </Box>

      <Section index="01" label="Posts" posts={posts} />
      <Section index="02" label="Case studies" posts={caseStudies} />
    </Box>
  );
}

export default WritingsList;
